import { ReactNode } from 'react';

import {
  MultipleChoiceListCorrect,
  MultipleChoiceListIncorrect,
} from '../multiple-choice';
import * as Styled from './multiple-choice-check.style';

import { ReactComponent as Tick } from 'lib/form/checkbox-input/tick.svg';

type Props = JSX.IntrinsicElements['input'] & {
  label?: ReactNode;
  disabled?: boolean;
  checked?: boolean;
  isCorrect?: boolean;
  isIncorrect?: boolean;
  isSelected?: boolean;
  onClick?: () => void;
};

const MultipleChoiceCheck = ({
  label,
  checked,
  disabled,
  isCorrect,
  isIncorrect,
  isSelected,
  onClick,
  ...inputProps
}: Props) => {
  const isCorrectAndNotSelected = !isSelected && isCorrect;
  const isIncorrectAndNotSelected = !isSelected && isIncorrect;
  return (
    <Styled.MultipleChoiceCheckboxLabel $disabled={disabled}>
      <Styled.MultipleChoiceCheckboxInput
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={onClick}
        {...inputProps}
      />
      {isCorrectAndNotSelected ? (
        <MultipleChoiceListCorrect />
      ) : isIncorrectAndNotSelected ? (
        <MultipleChoiceListIncorrect />
      ) : (
        <>
          <Styled.MultipleChoiceCheckboxDecor>
            <Tick width={16} height={16} />
          </Styled.MultipleChoiceCheckboxDecor>
          <Styled.MultipleChoiceCheckboxFocus />
        </>
      )}
      {label}
    </Styled.MultipleChoiceCheckboxLabel>
  );
};

export default MultipleChoiceCheck;
